import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Page,
  Layout,
  Card,
  BlockStack,
  Text,
  Button,
  InlineStack,
  Badge
} from '@shopify/polaris';
// Removed LogOutMinor import - icon not available in current Polaris version
import { useAuth } from '../contexts/AuthContext';

export const DashboardPage = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Page
      title="Dashboard"
      primaryAction={{
        content: 'Logout',
        onAction: handleLogout,
        variant: 'tertiary'
      }}
    >
      <Layout>
        <Layout.Section>
          <Card>
            <BlockStack gap="loose">
              <div>
                <Text variant="headingMd" fontWeight="bold">
                  Welcome, {user?.name}!
                </Text>
                <Text variant="bodyMd" color="subdued">
                  You are successfully logged in to the system.
                </Text>
              </div>
              
              <div className="grid-layout grid-2-columns">
                <div className="status-item">
                  <Text variant="bodySm" fontWeight="bold" className="status-label">
                    Email
                  </Text>
                  <div className="status-value">
                    {user?.email}
                  </div>
                </div>
                
                <div className="status-item">
                  <Text variant="bodySm" fontWeight="bold" className="status-label">
                    Status
                  </Text>
                  <div className="status-value">
                    <Badge status="success">Active</Badge>
                  </div>
                </div>
              </div>
            </BlockStack>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <Card>
            <BlockStack gap="loose">
              <Text variant="headingMd" fontWeight="bold">
                Quick Actions
              </Text>
              
              <div className="grid-layout grid-2-columns">
                <Button
                  variant="secondary"
                  fullWidth
                  onClick={() => navigate('/workspace')}
                >
                  Go to Main App
                </Button>
                
                {isAdmin && (
                  <Button
                    variant="primary"
                    fullWidth
                    onClick={() => navigate('/admin')}
                  >
                    Admin Panel
                  </Button>
                )}
                
                {!isAdmin && (
                  <Button
                    variant="secondary"
                    fullWidth
                    onClick={() => navigate('/configuration')}
                  >
                    Configuration
                  </Button>
                )}
              </div>
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
};
